import dayjs from 'dayjs';
import { IDynamicTariff } from 'app/shared/model/dynamic-tariff.model';
import { IProduct } from 'app/shared/model/product.model';

export interface IHourlyProductUsage {
  id?: number;
  from?: dayjs.Dayjs | null;
  util?: dayjs.Dayjs | null;
  hourlyUsage?: number | null;
  tariff?: IDynamicTariff | null;
  product?: IProduct | null;
}

export const defaultValue: Readonly<IHourlyProductUsage> = {};
